import {
    PLAYER_ACTIVITY_FAIL,
    PLAYER_ACTIVITY_REQUEST, PLAYER_ACTIVITY_SUCCESS,
    PLAYER_CREATE_FAIL,
    PLAYER_CREATE_REQUEST,
    PLAYER_CREATE_RESET,
    PLAYER_CREATE_SUCCESS,
    PLAYER_DELETE_FAIL,
    PLAYER_DELETE_REQUEST,
    PLAYER_DELETE_RESET,
    PLAYER_DELETE_SUCCESS,
    PLAYER_DETAILS_FAIL,
    PLAYER_DETAILS_REQUEST,
    PLAYER_DETAILS_SUCCESS,
    PLAYER_LIST_FAIL,
    PLAYER_LIST_REQUEST,
    PLAYER_LIST_SUCCESS,
    PLAYER_LOG_DATES_FAIL,
    PLAYER_LOG_DATES_REQUEST,
    PLAYER_LOG_DATES_SUCCESS, PLAYER_LOG_FOR_DATE_FAIL, PLAYER_LOG_FOR_DATE_REQUEST,
    PLAYER_LOG_FOR_DATE_SUCCESS, PLAYER_RESTART_FAIL, PLAYER_RESTART_REQUEST, PLAYER_RESTART_SUCCESS,
    PLAYER_UPDATE_DETAILS_FAIL,
    PLAYER_UPDATE_DETAILS_REQUEST,
    PLAYER_UPDATE_DETAILS_RESET,
    PLAYER_UPDATE_DETAILS_SUCCESS
} from '../constants/playerConstants';

export const playerListReducer = (state = {players: []}, action) => {
    switch (action.type) {
        case PLAYER_LIST_REQUEST:
            return {loading: true, players: []};
        case PLAYER_LIST_SUCCESS:
            return {loading: false, players: action.payload};
        case PLAYER_LIST_FAIL:
            return {loading: false, error: action.payload};
        default:
            return state;
    }
};

export const playerCreateReducer = (state = {}, action) => {
    switch(action.type){
        case PLAYER_CREATE_REQUEST:
            return {loading: true};
        case PLAYER_CREATE_SUCCESS:
            return {loading: false, player: action.payload};
        case PLAYER_CREATE_FAIL:
            return {loading: false, error: action.payload};
        case PLAYER_CREATE_RESET:
            return {loading: false, error: null};
        default:
            return state;
    }
};

export const playerDetailsReducer = (state = {player: {}}, action) => {
    switch (action.type) {
        case PLAYER_DETAILS_REQUEST:
            return {...state, loading: true};
        case PLAYER_DETAILS_SUCCESS:
            return {loading: false, player: action.payload};
        case PLAYER_DETAILS_FAIL:
            return {loading: false, error: action.payload};
        default:
            return state;
    }
};

export const playerUpdateDetailsReducer = (state = {player: {}}, action) => {
    switch (action.type) {
        case PLAYER_UPDATE_DETAILS_REQUEST:
            return {loading: true};
        case PLAYER_UPDATE_DETAILS_SUCCESS:
            return {loading: false, success: true, player: action.payload};
        case PLAYER_UPDATE_DETAILS_FAIL:
            return {loading: false, error: action.payload};
        case PLAYER_UPDATE_DETAILS_RESET:
            return {player: {}};
        default:
            return state;
    }
};

export const playerDeleteReducer = (state = {success: false}, action) => {
    switch (action.type) {
        case PLAYER_DELETE_REQUEST:
            return {loading: true, ...state};
        case PLAYER_DELETE_SUCCESS:
            return {loading: false, success: true};
        case PLAYER_DELETE_FAIL:
            return {loading: false, success: false, error: action.payload};
        case PLAYER_DELETE_RESET:
            return {loading: false, success: false, error: null};
        default:
            return state;
    }
};

export const playerLogDatesReducer = (state = { dates: [] }, action) => {
    switch (action.type){
        case PLAYER_LOG_DATES_REQUEST:
            return {loading: true, dates: [], error: null};
        case PLAYER_LOG_DATES_SUCCESS:
            return {loading: false, dates: action.payload, error: null};
        case PLAYER_LOG_DATES_FAIL:
            return {loading: false, dates: [], error: action.payload};
        default:
            return state;
    }
};

export const playerLogForDateReducer = (state = { logs: {} }, action) => {
    switch (action.type){
        case PLAYER_LOG_FOR_DATE_REQUEST:
            return {loading: true, logs: {}, error: null};
        case PLAYER_LOG_FOR_DATE_SUCCESS:
            return {loading: false, logs: action.payload, error: null};
        case PLAYER_LOG_FOR_DATE_FAIL:
            return {loading: false, logs: {}, error: action.payload};
        default:
            return state;
    }
};

export const playerRestartReducer = (state = {}, action) => {
    switch (action.type) {
        case PLAYER_RESTART_REQUEST:
            return {loading: true};
        case PLAYER_RESTART_SUCCESS:
            return {loading: false};
        case PLAYER_RESTART_FAIL:
            return {loading: false, error: action.payload};
        default:
            return state;
    }
};

export const playerActivityReducer = (state = {activities: []}, action) => {
    switch (action.type) {
        case PLAYER_ACTIVITY_REQUEST:
            return {loading: true, activities: [], error: null};
        case PLAYER_ACTIVITY_SUCCESS:
            return {loading: false, activities: action.payload, error: null};
        case PLAYER_ACTIVITY_FAIL:
            return {loading: false, error: action.payload};
        default:
            return state;
    }
};
